import type { SignalDrilldown } from "@repo/app-types/entities/signal";
import { ChartCard } from "@repo/ui/Cards/chartCard";
import type { FC, ReactNode } from "react";
import {
  DeltaPill,
  formatDeltaPoints,
} from "../../teammatePerformance/monthInReview/deltaPill.js";
import {
  computeAndFormatPercent,
  computePercent,
} from "../signalStatsFormatters.js";

export const SignalSummary: FC<{
  stats: SignalDrilldown;
  priorStats: SignalDrilldown;
  dateRangeDays: number;
}> = ({ stats, priorStats, dateRangeDays }) => {
  const currentRate = computePercent(
    stats.totalMatchCount,
    stats.totalInteractionCount,
  );
  const priorRate = computePercent(
    priorStats.totalMatchCount,
    priorStats.totalInteractionCount,
  );
  const delta = formatDeltaPoints(currentRate, priorRate);

  return (
    <ChartCard className="h-full">
      <div className="flex h-full flex-col">
        <SummaryMetric
          value={
            <span className="text-3xl font-bold text-foreground">
              {computeAndFormatPercent(
                stats.totalMatchCount,
                stats.totalInteractionCount,
              )}
            </span>
          }
          label="Match rate"
        />
        <div className="h-px w-full bg-gray-200" />
        <SummaryMetric
          value={
            <span className="text-3xl font-bold text-foreground tabular-nums">
              {stats.totalMatchCount.toLocaleString()}
            </span>
          }
          label={`of ${stats.totalInteractionCount.toLocaleString()} calls`}
        />
        <div className="h-px w-full bg-gray-200" />
        <SummaryMetric
          value={<DeltaPill delta={delta.delta} tone={delta.tone} />}
          label={`vs prior ${dateRangeDays} days`}
        />
      </div>
    </ChartCard>
  );
};

const SummaryMetric: FC<{
  value: ReactNode;
  label: string;
}> = ({ value, label }) => (
  <div className="flex flex-1 flex-col justify-center gap-1">
    <div className="flex items-center">{value}</div>
    <span className="text-xs font-medium text-gray-400">{label}</span>
  </div>
);
